import React from 'react';

const BlogCardStandard = ({ data }) => {
    const { img, author, date, title } = data;
    return (
        <article className="blog_post">
            <div className="post_img">
                <img src={img} alt="blog" />
            </div>
            <div className="post_content">
                <div className="post_header">
                    <div className="metalist">
                        <span className="author"><a href="#"><i className="ion-android-create"></i> {author}</a></span>, &nbsp;&nbsp;
                        <span className="calendar"><a href="#">{date}</a></span>
                    </div>
                    <h3 className="post_title">
                        <a href="/blog-details">{title}</a>
                    </h3>
                </div>
                <div className="post_intro">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit tempor incididunt ut labore et dolore magna aliqua. Ut en ad minim veniam, quis nostrud exercitation ullamco labLorem ipsum dolor sit amet, consectetur adipiscing elit tempor incididunt ut labore et dolore magna aliqua. Ut en ad minim veniam, quis nostrud exercitation ullamco labaliquip ex ea commodo consequat. Penat mpor incididunt ut labore et dolore magna aliqua....</p>
                </div>
                <div className="post_footer">
                    <div className="read_more">
                        <a href="/blog-details">Continue Reading</a>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default BlogCardStandard;